import FeedbackPage from "./FeedbackPage";

export default FeedbackPage;